<template>
  <AppBtn primary block type="submit">
    {{ $tt('contact_page.send_msg') }}
  </AppBtn>
</template>